<div class="grid gap-6" *ngIf="data">
    <sl-select label="Template" i18n-label [(ngModel)]="data.templateMode">
        <sl-menu-item value="Default" i18n>Default Template</sl-menu-item>
        <sl-menu-item value="Custom" i18n>Custom Template</sl-menu-item>
    </sl-select>

    <sl-textarea *ngIf="data.templateMode==='Default'" [value]="renderedExample" label="Example" i18n-label readonly help-text="Texts surrounded by double asterisks (**) will be marked with bold text" i18n-help-text></sl-textarea>

    <sl-textarea *ngIf="data.templateMode==='Custom'" [(ngModel)]="data.template" label="Text" i18n-label help-text="Texts surrounded by double asterisks (**) will be marked with bold text" i18n-help-text></sl-textarea>
</div>

<sl-divider></sl-divider>

<div class="text-right">
    <sl-button (click)="close()" i18n>Cancel</sl-button>
    <sl-button (click)="ok()" class="ml-3" type="primary" i18n>OK</sl-button>
</div>